// Header.tsx
import React from "react";
import Select from "react-select";
import { TabType } from "./types";

type HeaderProps = {
  activeTab: TabType;
  setShowWithoutPrescriptionOrderDetails: (val: boolean) => void;
  setShowOrderHistory: (val: boolean) => void;
  withPrescription: boolean;
  setWithPrescription: (val: boolean) => void;
  orderStatus: "new" | "awaiting" | "approved";
  setOrderStatus: (val: "awaiting" | "approved") => void;
};

const Header: React.FC<HeaderProps> = ({
  activeTab,
  setShowWithoutPrescriptionOrderDetails,
  setShowOrderHistory,
  withPrescription,
  setWithPrescription,
  orderStatus,
  setOrderStatus,
}) => {
  const prescriptionOptions = [
    { value: "with", label: "With Prescription" },
    { value: "without", label: "Without Prescription" },
  ];

  const orderStatusOptions = [
    { value: "awaiting", label: "Awaiting Approval" },
    { value: "approved", label: "Approved" },
  ];
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        {/* Prescription Filter */}
        <div className="flex items-center space-x-2  text-blue-600 px-3 py-2 rounded-lg">
          {activeTab === "medicine" && (
            <Select
              value={prescriptionOptions.find(
                (opt) => opt.value === (withPrescription ? "with" : "without")
              )}
              onChange={(selected) => {
                const selectedValue = selected?.value === "with";
                setWithPrescription(selectedValue);
                setShowWithoutPrescriptionOrderDetails(!selectedValue);
              }}
              options={prescriptionOptions}
              className="text-sm"
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: "#ecfeff", // bg-cyan-50
                  borderColor: "#e5e7eb", // border-gray-200
                  minHeight: "36px",
                  boxShadow: "none",
                  cursor: "pointer",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "#06b6d4"
                    : state.isFocused
                    ? "#e0f7fa"
                    : "white",
                  color: state.isSelected ? "white" : "#374151",
                  fontSize: "11px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }),
              }}
              isSearchable={false}
            />
          )}
        </div>

        {/* Order Status Dropdown */}
        {withPrescription && (
          <Select
            value={orderStatusOptions.find((opt) => opt.value === orderStatus)}
            onChange={(selected) =>
              setOrderStatus(selected?.value as "awaiting" | "approved")
            }
            options={orderStatusOptions}
            className="text-sm"
            styles={{
              control: (base) => ({
                ...base,
                backgroundColor: "white",
                borderColor: "#e5e7eb",
                minHeight: "36px",
                boxShadow: "none",
                cursor: "pointer",
                width: "200px",
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? "#2563eb"
                  : state.isFocused
                  ? "#e0e7ff"
                  : "white",
                color: state.isSelected ? "white" : "#374151",
                fontSize: "11px",
                cursor: "pointer",
              }),
            }}
            isSearchable={false}
          />
        )}

        {/* Order History Button */}
        <button
          className="text-blue-600 px-3 py-2 rounded-lg hover:bg-blue-50 transition-colors"
          onClick={() => setShowOrderHistory(true)}
        >
          Order History
        </button>
      </div>
    </div>
  );
};

export default Header;
